<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Hook" id="auto_bookmark_toc_1">C’était Amy qui avait parlé la première.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Marketa et moi avons eu une idée folle.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Ondrej s’était installé dans un des fauteuils confortables et avait attendu.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— J’ai cru comprendre que vous souhaitez rester dans ce pays, avait dit Marketa.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Ondrej avait regardé autour de lui.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Est-ce que vous me proposez un travail ?</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Non, avait répondu Archie. Malheureusement, je ne peux pas me permettre de vous engager à plein temps. Ce serait un arrangement d’un autre genre.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Ondrej avait jeté un coup d’œil à l’homme inconnu dans la pièce. Il aurait voulu demander qui il était, mais il avait été trop troublé pour parler.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Je vais être franche. Nous contrôlons les antécédents de tous les nouveaux employés, et quelque chose d’intéressant est apparu dans les vôtres, avait dit Marketa.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Ondrej avait compris en un éclair qu’ils savaient pour sa fortune.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— Mon argent, avait-il dit.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">L’inconnu s’était penché en avant.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">— M. Katsaros souhaite vous faire une proposition.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?4557fd4a